import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ChatVideoLink } from "@redotech/redo-web/ai/chat/components/chat-video-link";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export const CUSTOM_ANALYTICS_REPORT_LINK_PREFIX =
  "/order-management/analytics/reports/custom/";

function getCustomAnalyticsReportIdFromLink(href: string): string | null {
  if (!href.startsWith(CUSTOM_ANALYTICS_REPORT_LINK_PREFIX)) {
    return null;
  }

  return href.slice(CUSTOM_ANALYTICS_REPORT_LINK_PREFIX.length) || null;
}

export function CustomAnalyticsReportMarkdownLink({
  href,
  children,
}: {
  href: string;
  children?: ReactNode;
}) {
  const navigate = useNavigate();
  const routes = useRequiredContext(MerchantRoutesContext);
  const customReportId = getCustomAnalyticsReportIdFromLink(href);

  if (!customReportId) {
    return <ChatVideoLink href={href}>{children}</ChatVideoLink>;
  }

  return (
    <Flex dir="column" mt="sm" w="full">
      <RedoButton
        hierarchy="primary"
        onClick={() =>
          navigate(`${routes.analyticsReportsHref}/custom/${customReportId}`)
        }
        size="sm"
        text="View custom report"
      />
    </Flex>
  );
}
